import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_PLAYERS_LIST_ROUTE_NAME } from '@modules/players/constants';
import {
  ADMIN_PLAYER_PROFILE_ROUTE_NAME,
  PLAYER_TRACKING_HISTORY_EDIT_ROUTE_NAME,
  TRANSLATION_PLAYER_DETAILS,
} from '@modules/players/submodules/PlayerProfile/constants';
import { PlayerActivityModule } from '@modules/players/submodules/PlayerProfile/submodules/PlayerActivity/PlayerActivityModule';
import { PlayerMainDataModule } from '@modules/players/submodules/PlayerProfile/submodules/PlayerMainData/PlayerMainDataModule';
import { PlayerTrackerModule } from '@modules/players/submodules/PlayerProfile/submodules/PlayerTracker/PlayerTrackerModule';
import { getTranslationKeys } from '@modules/players/submodules/PlayerProfile/translations';

import { PLAYER_ACTIVITY_ROUTE } from './submodules/PlayerActivity/constants';
import { PLAYER_MAIN_DATA_ROUTE } from './submodules/PlayerMainData/constants';
import { PLAYER_TRACKER_ROUTE } from './submodules/PlayerTracker/constants';

export class PlayerProfileModule extends AppModule {
  protected submodules = [
    new PlayerMainDataModule(),
    new PlayerActivityModule(),
    new PlayerTrackerModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PLAYERS_LIST_ROUTE_NAME, {
      name: ADMIN_PLAYER_PROFILE_ROUTE_NAME,
      path: 'profile/:id',
      component: () => import('@modules/players/submodules/PlayerProfile/pages/PlayerProfileDialogPage/PlayerProfileDialogPage.vue'),
      redirect: { name: PLAYER_TRACKER_ROUTE },
      props: {
        backTo: { name: ADMIN_PLAYERS_LIST_ROUTE_NAME },
        mainDataRoute: { name: PLAYER_MAIN_DATA_ROUTE },
        activityRoute: { name: PLAYER_ACTIVITY_ROUTE },
        trackerRoute: { name: PLAYER_TRACKER_ROUTE },
        editHistoryRoute: { name: PLAYER_TRACKING_HISTORY_EDIT_ROUTE_NAME },
      },
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_PLAYER_DETAILS, getTranslationKeys);
  }
}
